module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/yes.c9b461e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/yes.jpg
// module id = Ujt2
// module chunks = 0